export default __webpack_public_path__ + "static/media/car-online.ea99187d.png";